import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const FadeInContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  left: calc(50% - ${size(0.5)});
  transition: all 200ms linear;
`;

export const FadeInDot = styled.div`
  flex: 0 0 auto;
  width: ${size(1)};
  height: ${size(1)};
  border-radius: 50%;
  background: ${theme.colors.dots.inactive};
  transition: 75ms linear;

  &.medium {
    transform: scale(0.75);
  }

  &.small {
    transform: scale(0.5);
  }

  &.hidden-dot {
    transform: scale(0);
  }

  &.active {
    background: ${theme.colors.dots.active};
  }

  & + & {
    margin-left: ${size(1)};
  }
`;
